import { useMemo } from 'react';

import { AspectRatio } from 'services/clip.service';
import { useAppSelector } from 'store/store-hooks';

import { enumToOptions } from 'components/app/_helpers/app-config.helper';
import { usePanZoomContext } from 'components/app/editor/pan-zoom/_pan-zoom.provider';
import { usePanZoomCb } from 'components/app/editor/pan-zoom/_mediator/use-pan-zoom-cb';
import { useSbPanZoomSeek } from 'components/app/storyboard/sb-pan-zoom/use-sb-pan-zoom-seek';
import { Path, useLocation } from 'components/_hooks/use-router';
import { selectClipData } from 'components/app/editor/_mediator/editor.slice';

import { Select } from 'components/UI/select/select';
import styles from '../_editor-config.module.scss';

const OPTIONS = enumToOptions(AspectRatio);

export const ConfigPanZoomAR = () => {
  const { path } = useLocation();
  const { onAspectRatio } = usePanZoomCb();
  const { panZoomRotate } = usePanZoomContext();
  const panZoomControl = useAppSelector((state) => state.sb.panZoomControl);
  const panZoomRotateData = useAppSelector(selectClipData)?.config.panZoomRotate ?? [null, null];

  const sbSeekToKey = useSbPanZoomSeek();

  const inactivePzControl = path === Path.storyboard && !panZoomControl;

  const value = useMemo(() => {
    if (!inactivePzControl) return panZoomRotate?.aspectRatio;
    return panZoomRotateData[0]?.aspectRatio ?? panZoomRotateData[1]?.aspectRatio ?? AspectRatio.orig;
  }, [inactivePzControl, panZoomRotate?.aspectRatio, panZoomRotateData]);

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    if (inactivePzControl) sbSeekToKey(0);
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onAspectRatio(parseInt(e.target.value) as AspectRatio);
  };

  return (
    <div className={styles.ConfigSelect} onClick={handleClick}>
      <span>AR</span>
      <Select
        className={styles.ConfigSelect__Select}
        onChange={handleChange}
        value={value}
        options={OPTIONS}
        disabled={inactivePzControl}
      />
    </div>
  );
};
